<!-- ABA INFORMAÇÕES BÁSICAS -->
<form [formGroup]="form" #f="ngForm">
  <div class="card-body">
    <div class="row">


      <div class="form-group col-md-3">
        <label for="numeroOsa" class="mb-1">Número da OSA</label>
        <input
          disabled
          type="text"
          id="numeroOsa"
          class="form-control form-control-sm"
          [ngModel]="model?.numero"
          [ngModelOptions]="{standalone: true}"
        />
      </div>
      <div class="form-group col-md-3">
        <label for="numeroOpa" class="mb-1">Número da OPA</label>
        <input
          disabled
          type="text"
          id="numeroOpa"
          class="form-control form-control-sm"
          [ngModel]="model?.planejamento?.opa?.numero"
          [ngModelOptions]="{standalone: true}"
        />
      </div>
      <div class="form-group col-md-3">
        <label for="origemAuditoria" class="mb-1"
        >Origem de Auditoria</label
        >
        <input
          disabled
          type="text"
          id="origemAuditoria"
          class="form-control form-control-sm"
          [ngModel]="model?.planejamento?.opa?.origem?.descricao"
          [ngModelOptions]="{standalone: true}"
        />
      </div>

      <div class="form-group col-md-3">
        <label for="dataElaboracao" class="mb-1">Data de Elaboração</label>
        <input
          disabled
          type="text"
          id="dataElaboracao"
          class="form-control form-control-sm"
          [ngModel]="
					model?.dataElaboracao
						| date: 'dd/MM/yyyy'
				"
          [ngModelOptions]="{standalone: true}"
        />
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="tipoAuditoria" class="mb-1">Tipo da Auditoria</label>
        <input
          disabled
          type="text"
          id="tipoAuditoria"
          class="form-control form-control-sm"
          [ngModel]="model?.planejamento?.opa?.tipoAuditoria?.nome"
          [ngModelOptions]="{standalone: true}"
        />
      </div>

      <div class="form-group col-md-6">
        <label for="tipoEnfase" class="mb-1">Tipo de Ênfase</label>
        <input type="text" [readonly]="true" class="form-control form-control-sm"
               [value]="model.planejamento?.opa?.tipoEnfase?.nome" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-6">
        <label class="mb-1">Unidade Gestora a ser auditada</label>
        <input type="text" [readonly]="true" class="form-control form-control-sm"
               [value]="model.unidadeGestora?.nome" />
      </div>

      <div class="form-group col-md-3">
        <label for="dataInicioPrevista" class="mb-1">Data prevista Início da Auditoria</label>
        <input
          type="text"
          id="dataInicioPrevista"
          class="form-control form-control-sm"
          [value]="model?.planejamento?.opa?.dataInicioPrevista | date: 'dd/MM/yyyy'"
          disabled
        />
      </div>

      <div class="form-group col-md-3">
        <label for="dataFimPrevista" class="mb-1">Data prevista Fim da Auditoria</label>
        <input
          type="text"
          id="dataFimPrevista"
          class="form-control form-control-sm"
          [value]="model?.planejamento?.opa?.dataFimPrevista | date: 'dd/MM/yyyy'"
          disabled
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="objeto" class="mb-1">Objeto</label>
        <textarea readonly style="resize: none" rows="4"
                  class="form-control form-control-sm"
                  [value]="model?.planejamento?.opa?.objeto"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-2">
        <label for="qtdeDiasUteis" class="mb-1">Qtde de Dias Úteis da Execução</label>
        <input
          type="number"
          id="qtdeDiasUteis"
          class="form-control form-control-sm"
          [(ngModel)]="model.qtdeDiasUteisExecucao"
          [ngModelOptions]="{ standalone: true }"
          required
          readonly
        />
      </div>

      <div class="form-group col-md-2">
        <label for="dataInicioRealizacao" class="mb-1">Data Início da Execução</label>
        <input
          type="date"
          class="form-control form-control-sm"
          id="dataInicioRealizacao"
          [attr.disabled]="ocultaSalvar || versao || visualizar || (model.osaOrigemId != null && model.osaOrigemId != undefined) ? true : null"
          formControlName="dataInicioRealizacao"
          [min]="dataElaboracao"
          (change)="atualizarMinDataFim()"
        />
      </div>

      <div class="form-group col-md-2">
        <label for="dataFimRealizacao" class="mb-1">Data Fim da Execução</label>
        <input
          type="date"
          class="form-control form-control-sm"
          id="dataFimRealizacao"
          formControlName="dataFimRealizacao"
          [min]="minDataFim"
          [class.disabled]="!minDataFim || ocultaSalvar || visualizar"
          [readonly]="!minDataFim || ocultaSalvar || visualizar"
        />
      </div>

      <div class="form-group col-md-3">
        <label for="dataConstatacoesPreliminares" class="mb-1">Data das constatações preliminares</label>
        <input type="date" [attr.disabled]="ocultaSalvar ||visualizar ? true : null"
               class="form-control form-control-sm"
               formControlName="dataConstatacoesPreliminares"
               [ngClass]="{ 'is-invalid': submitted && form.controls['dataConstatacoesPreliminares'].invalid }">
      </div>

      <div class="form-group col-md-3">
        <label for="dataApresentacaoRelatorio" class="mb-1">Data para apresentação do relatório</label>
        <input type="date" [attr.disabled]="ocultaSalvar || visualizar ? true : null"
               class="form-control form-control-sm"
               formControlName="dataApresentacaoRelatorio"
               [ngClass]="{ 'is-invalid': submitted && form.controls['dataApresentacaoRelatorio'].invalid }">
      </div>
    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="periodoAuditado" class="mb-1">Período a ser auditado</label>
        <input
          type="text"
          id="periodoAuditado"
          [attr.disabled]="ocultaSalvar || visualizar ? true : null"
          class="form-control form-control-sm"
          formControlName="periodoAuditado"
          placeholder="Ex: Jan/2024 a Mar/2024"
        />
      </div>


      <div class="form-group col-md-6">
        <label for="responsavelUg" class="mb-1"
        >Coordenador da auditoria</label
        >
        <div class="input-group input-group-sm">
          <input type="text" name="table_search" class="form-control form-control-sm " disabled
                 type="text"
                 class="form-control form-control-sm"
                 [ngClass]="{ 'invalid': submitted && form.controls['auditor'].invalid }"
                 formControlName="auditor"
          />
          <div *ngIf="submitted && form.controls['auditor'].invalid" class="invalid-feedback">
            <div *ngIf="form.controls['auditor'].errors.required">Campo obrigatório*</div>
          </div>

          <div class="input-group-append">
            <button type="button" [attr.disabled]=" isSubsidiaria || visualizar ? true : null" class="btn btn-info"
                    (click)="exibirModalCoordenadorAuditoria()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">

        <div class="mat-elevation-z4 mb-4">
          <table
            [hidden]="subtipoDataSource.data.length === 0"
            mat-table
            [dataSource]="subtipoDataSource"
            matSort
            #tabela1="matSort"
            matSortDirection="asc"
          >

            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>SubTipo(s)</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.nome }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsSubtipo"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsSubtipo"></tr>
          </table>

          <h5 [hidden]="subtipoDataSource.data.length !== 0" class="table-no-data">
            Nenhum registro encontrado.
          </h5>

          <mat-paginator
            [pageSizeOptions]="[5]"
            #tableOnePaginator="matPaginator"
            showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
      <div class="form-group col-md-6">
        <div class="mat-elevation-z4 mb-4">
          <table
            mat-table
            [dataSource]="equipeDataSource"
            matSort
            #tabela2="matSort"
          >
            <ng-container matColumnDef="auditor">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Equipe de Auditores</th>
              <td mat-cell *matCellDef="let element">
    <span *ngIf="element.indisponivelPeriodo" style="color: red;">
      <i
        class="fas fa-exclamation-triangle"
        [title]="'Auditor indisponível para o período,está com a dispensa' + (element.nomeDispensa ? ' - ' + element.nomeDispensa : '')">
      </i>
      {{ element.nomeAuditor }}
    </span>
                <span *ngIf="!element.indisponivelPeriodo">
      {{ element.nomeAuditor }}
    </span>
              </td>
            </ng-container>
            <ng-container matColumnDef="unidadeVinculadas">
              <th mat-header-cell *matHeaderCellDef>Unidade(s) Gestora(s)</th>
              <td mat-cell *matCellDef="let element">
                <div *ngIf="element.unidadesVinculadas && element.unidadesVinculadas.length > 0; else semVinculo">
                    <span *ngFor="let sigla of element.unidadesVinculadas; let last = last"
                          class="badge bg-primary text-white me-1">
                      {{ sigla }}
                    </span>
                </div>
                <ng-template #semVinculo>
                  <span class="text-muted">-</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Coluna Ações -->
            <ng-container matColumnDef="acoes">
              <th mat-header-cell *matHeaderCellDef class="text-right">
                <button
                  *ngIf="!visualizar && !ocultaSalvar"
                  type="button"
                  class="btn btn-success btn-xs"
                  (click)="exibirModalAlocarEquipe()"
                >
                  Alocar Equipe <i class="far fas fa-plus fa-sm"></i>
                </button>
              </th>
              <td
                mat-cell
                *matCellDef="let element;"
                class="block"
              >
                <div class="d-flex justify-content-end align-items-center p-0">
                  <button
                    *ngIf="!visualizar && !ocultaSalvar"
                    type="button"
                    class="icon-btn btn btn-primary btn-xs text-left"
                    style="margin-right: 32px !important; height: 20px;"
                    (click)="abrirModalVincularUnidade(element)"
                  >
                    <i class="far fas fa-pen fa-sm" style="font-size: 13px;"></i>
                  </button>
                  <button
                    *ngIf="!visualizar && !ocultaSalvar"
                    type="button"
                    class="btn btn-danger btn-group-xs p-1 mr-2 d-flex justify-content-center align-items-center"
                    style="margin-right: 32px !important; height: 20px;"
                    (click)="desvincularAuditor(element.id)"
                  >
                    <i class="far fa-trash-alt" style="font-size: 13px;"></i>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <h5 [hidden]="equipeDataSource.data.length > 0" class="table-no-data">
            Nenhum registro encontrado.
          </h5>
          <mat-paginator [pageSizeOptions]="[5]" #TableTwoPaginator="matPaginator">
          </mat-paginator>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label class="mt-4">Lista de Ugs</label>
        <div class="mat-elevation-z4 mb-4">
          <table mat-table class="w-100" [dataSource]="dataSourceUgSubTipos" matSortDisableClear #tabela3="matSort"
                 matSort
                 matSortDirection="asc">

            <ng-container matColumnDef="ug">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Unidade(s) Gestora(s)
              </th>
              <td mat-cell *matCellDef="let element" class="text limit-text">
                {{ element?.unidadeGestoraNome }}
              </td>
            </ng-container>

            <ng-container matColumnDef="subtipo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Subtipo
              </th>
              <td mat-cell *matCellDef="let element" class="text limit-text">
                {{ element?.subtipoAuditoriaNome }}
              </td>
            </ng-container>

            <ng-container matColumnDef="statusUg">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Status UG's</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.statusUg || 'Sem status' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="numeroOsa">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Nº Osa</th>
              <td mat-cell *matCellDef="let element">
                {{ element?.numeroOsa || '-' }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsUg" class="bg-light"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsUg"></tr>
          </table>

          <h5 class="table-no-data" [hidden]="dataSourceUgSubTipos?.data?.length > 0">
            Nenhuma Ug vinculada
          </h5>

          <mat-paginator
            #tableTreePaginator="matPaginator"
            [hidden]="!(dataSourceUgSubTipos?.data?.length > 0)"
            [pageSizeOptions]="[5]"
            showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="txtNotaRodape" class="mb-1">Nota de Rodapé</label>
        <textarea
          rows="3"
          id="txtNotaRodape"
          [attr.disabled]="visualizar ? true : null"
          class="form-control form-control-sm"
          maxlength="500"
          formControlName="notaRodape"
          [ngClass]="{ 'is-invalid': submitted && form.controls['notaRodape'].invalid }"
        >
			</textarea>
      </div>
    </div>
  </div>
</form>
